import styled from 'styled-components';
import { StockCardStyledAC } from './StockCardStyled.AC';

export const StockCardStyledACGB = styled(StockCardStyledAC)``;
